<template>
<div class="news-main">
<div class="about-top">
  <img src="../assets/abtus_banner.png" style="max-width:100%;" width="100%" />
</div>
<el-container class="news-main-container">
  <el-aside width="200px" height="auto" style="">

    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="vertical" @select="handleSelect">
      <li  class="" style="padding-left: 20px;height: 40px;background:#2fa5ff; color:#fff;    line-height: 40px; vertical-align: middle;line-height: 40px;">新闻中心</li>
      <el-menu-item class="new-menu" index="0">公司新闻</el-menu-item>
      <el-menu-item class="new-menu" index="1">行业新闻</el-menu-item>
    </el-menu>
  </el-aside>
  <el-container class="news-content">
    <el-main>
      <div class="main-title">&nbsp;&nbsp;&nbsp;{{ type == 0?"公司新闻":"行业新闻"}}</div>
      <hr style="height:1px;border:none;border-top:1px solid #d0dee5;" />
      <table border="0" width="100%">
        <tbody>
         <tr v-for="item in tableData" :key="item.id" >
            <td class="fisrt-td" style=""><img :src="item.image_url"  ></td>
            <td class="second-td" valign="top" style="">
              <div class="news-title">
                <font style="" color="#333333"><a :href="'#/website/news_detail?id='+item.id" style="text-decoration: none;color: #333;">{{item.title}}</a></font>
                <br style="clear:both;" />
              </div>
              <div class="news-desc">
                <font style="" color="#666666">{{item.desc}}</font>
                <br style="clear:both;" />
              </div>
            </td>
            <td valign="top" class="news-date">
              {{item.date}}
            </td>
        </tr>
        </tbody>
      </table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
        style="float:right;">>
      </el-pagination>
    </el-main>
  </el-container>
</el-container>
</div>
</template>
<style scoped>


@media screen and (max-width: 1280px) {
  .fisrt-td {
    width:10%;
  }
  .second-td {
    width: 66%;
    font-size: 20px;
    padding-left: 20px;
  }
  .fisrt-td img {
    width: 200px;
   /* height: 160px;*/
  }
  .news-desc {
    font-size: 14px;
  }
  .news-date {
    font-size: 12px;
  }
}

.second-td {
    font-family: "Microsoft Yahei";
}
.news-desc {
  padding-top: 15px;
}
@media screen and (max-width: 1579px) and  (min-width: 1281px) {
  .fisrt-td {
    /*width:10%;*/
  }
  .second-td {
    width: 67%;

    padding-left: 4px;
    padding-right: 30px;
    font-size: 20px;
  }
  .fisrt-td img {
    width: 200px;
   /* height: 160px;*/
  }
  .news-desc {
    font-size: 14px;
  }
  .news-date {
    font-size: 12px;
  }

}

@media screen and (min-width: 1580px) {
  .fisrt-td {
    width:10%;
  }

  .second-td {
    width: 70%;
    font-size:24px;
    padding-left: 24px;
  }
  .fisrt-td img {
   width: 220px;
   /*  height: 160px;*/
  }
  .news-desc {
    font-size:16px;
  }

}
  .el-header {
    /*background-color: #B3C0D1;*/
    /*color: #333;*/
    line-height: 60px;
    margin:0 auto;
    
  }

  .news-main {
    /*text-align: center;*/
    margin-top: 60px;
    /* background-color: #F5F5F5; */
  }
  .el-menu {
    /* border-right: solid 0px!important; */
	    background: rgba(255,255,255,1);
		box-shadow: 0px 0px 14px 2px rgba(223,223,223,0.68);
		margin: 10px;
	}
	.el-main{
		background: rgba(255,255,255,1);
		box-shadow: 0px 0px 14px 2px rgba(223,223,223,0.68);
	}
  .news-content {
    background-color: #FFFFFF;
    margin-top: 10px;
    /* margin-left: 20px; */
  } 
  .el-menu-select-box li {
		margin: 0 20px;
	}
  .news-main-container {
    margin:0 auto;
    width: 90%;
    padding-top: 10px;
  }
  .new-menu.is-active {
	  background: #EAF6FF;
    border-left: solid 2px #409EFF;
  }
  .el-main {
    padding-top: 0px;
    background-color: #FFFFFF;
  }
  .el-menu {
    border-right: solid 0px!important;
  }
  .news-content {
    background-color: #FFFFFF;
    margin-left: 20px;
    margin-bottom: 20px;
  }
  .el-aside {
    /*background-color: white;*/
  }
  table{border-collapse: collapse;}

  table tr{border-bottom:solid 1px #d0dee5;}
  table td {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  img {
    display : block ;
  }
  .main-title{
    border-left: solid 4px #409EFF;
    margin-top: 10px;
  }
</style>

<script>
  import axios from 'axios';
  export default {
    name:"media",
    data() {
      return {
        tableData: [],
        activeIndex:"0",
        total: 0,
        page: 1,
        pageSize: 30,
        type: 0,
      }
    },
    methods: {
      handleCurrentChange(val) {
          this.page = val;
          this.getNews(0);
      },

      getNews() {
          axios.get(this.base+`/rest/account/api/news_list`, {params:{type:this.type, page:this.page, page_size:this.page_size}}).then(res => {
            if (res.data.code == 200) {
              this.tableData = res.data.data.items;
              this.total = res.data.data.total_count;
            }
          });
      },
      handleSelect(val) {
        this.type = val;
        this.getNews();
      }
    },
    mounted(){
      this.getNews(0)
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/News.vue